import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import { Status } from "core/models/error";
import type { ApiError } from "core/client";


const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			refetchOnWindowFocus: false,
			staleTime: 600000, // 10 min
			retry: false,
			throwOnError: (e: ApiError) => {
				if (e.type === Status[400] || e.type === Status[404]) return false;
				else return true;
			}
		}
	}
});


export const getContext = () => ({ queryClient, auth0: undefined });

export default function QueryProvider({ children }: { children: React.ReactNode }) {
	return (
		<QueryClientProvider client={queryClient}>
			{children}
		</QueryClientProvider>
	);
}